var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutActionPrint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M915.69,342.65H108.31c-43.32,0-78.77,35.45-78.77,78.77v275.69c0,43.32,35.45,78.77,78.77,78.77h116.18v114.22c0,43.32,35.45,78.77,78.77,78.77h419.45c43.32,0,78.77-35.45,78.77-78.77v-114.22h116.18c43.32,0,78.77-35.45,78.77-78.77v-275.69c-1.97-43.32-37.42-78.77-80.74-78.77h0ZM163.45,545.48c-33.48,0-59.08-25.6-59.08-59.08s25.6-59.08,59.08-59.08,59.08,25.6,59.08,59.08-25.6,59.08-59.08,59.08ZM706.95,848.74c0,15.75-13.78,29.54-29.54,29.54h-334.77c-15.75,0-29.54-13.78-29.54-29.54v-192.98c0-15.75,13.78-29.54,29.54-29.54h334.77c15.75,0,29.54,13.78,29.54,29.54v192.98ZM797.54,218.58c0,15.75-13.78,29.54-29.54,29.54H252.06c-15.75,0-29.54-13.78-29.54-29.54V84.68c0-15.75,13.78-29.54,29.54-29.54h515.94c15.75,0,29.54,13.78,29.54,29.54v133.91h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutActionPrint);
export default __webpack_public_path__ + "static/media/workout-action-print.6435273e34eee4196e2c874aadd951c9.svg";
export { ForwardRef as ReactComponent };